<template>
  <!-- begin:: Header -->
  <div
    style="left: 0;"
    id="kt_header"
    ref="kt_header"
    class="header"
    v-bind:class="headerClasses"
  >
    <!--justify-content-between-->
    <div
      class="container-fluid align-items-center justify-content-lg-center">
      <!-- begin:: Header Menu -->
      <div class="header-menu-wrapper header-menu-wrapper-left w-100 mt-2" ref="kt_header_menu_wrapper">
        <div style="" id="kt_header_menu" ref="kt_header_menu" class="header-menu header-menu-mobile" v-if="headerMenuEnabled" v-bind:class="headerMenuClasses">
          <!-- example static menu here -->
          <b-row class="w-100 justify-content-between align-items-center" style="min-width: 1650px !important;">
            <b-col cols="1" class="cursor-pointer" @click="goMain();">
              <h1 style="" class="py-3">ARGOS</h1>
            </b-col>
            <b-col class="justify-content-center d-flex align-items-center p-0">
              <KTMenu />
            </b-col>
            <div class="font-weight-bolder d-flex align-items-center">
              <a :href=customerSupportLink target="_blank" class="d-block text-center mr-5">
                <span>{{ $t("CustomerSupport") }}</span>
                <b-icon icon="box-arrow-in-up-right" style="margin-left: 3px"></b-icon>
              </a>
            </div>
            <div class="font-weight-bolder d-flex align-items-center">
              <a :href=announcementLink target="_blank" class="d-block text-center mr-10">
                <span>{{ $t("Announcement") }}</span>
                <b-icon icon="box-arrow-in-up-right" style="margin-left: 3px"></b-icon>
              </a>
                <KTTopbar/>
            </div>
          </b-row>
        </div>
      </div>
      <!-- end:: Header Menu -->


    </div>

  </div>
  <!-- end:: Header -->
</template>

<script>
import { mapGetters } from "vuex";
import KTTopbar from "@/view/layout/header/TopbarCustom.vue";
import KTLayoutHeader from "@/assets/js/layout/base/header.js";
import KTLayoutHeaderMenu from "@/assets/js/layout/base/header-menu.js";
import KTMenu from "@/view/layout/header/Menu.vue";


export default {
  name: "KTHeader",
  components: {
    KTTopbar,
    KTMenu
  },

  mounted() {
    // Init Desktop & Mobile Headers
    KTLayoutHeader.init("kt_header", "kt_header_mobile");

    // Init Header Menu
    KTLayoutHeaderMenu.init(
      this.$refs["kt_header_menu"],
      this.$refs["kt_header_menu_wrapper"]
    );


  },
  methods :  {


    goMain() {
      if( this.$route.name !== 'project-list' ) {
        this.$router.push( { name : "project-list" } )
      }
    }
  },
  computed: {
    ...mapGetters(["layoutConfig", "getClasses"]),



    /**
     * Check if the header menu is enabled
     * @returns {boolean}
     */
    headerMenuEnabled() {
      return !!this.layoutConfig("header.menu.self.display");
    },

    /**
     * Get extra classes for header based on the options
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses("header");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },

    /**
     * Get extra classes for header menu based on the options
     * @returns {null|*}
     */
    headerMenuClasses() {
      const classes = this.getClasses("header_menu");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },
    currentI18n() {
      return this.$i18n.locale;
    },
    customerSupportLink() {
      if (this.currentI18n === "en") {
        return "https://support.argosidentity.com/hc/en-us/requests/new?&tf_10220460827407=client_-_i_have_a_contract_with_argos&tf_5571572300559=kyc";
      } else {
        return "https://support.argosidentity.com/hc/ko/requests/new?&tf_10220460827407=client_-_i_have_a_contract_with_argos&tf_5571572300559=kyc";
      }
    },
    announcementLink() {
      if (this.currentI18n === "en") {
        return "https://support.argosidentity.com/hc/en-us/categories/11041648438415-Announcement";
      } else {
        return "https://support.argosidentity.com/hc/ko/categories/11041648438415-%EC%95%84%EB%A5%B4%EA%B3%A0%EC%8A%A4-%EA%B3%B5%EC%A7%80%EC%82%AC%ED%95%AD";
      }
    }
  },



};
</script>
